import { Image } from 'components/Image'
import dynamic from 'next/dynamic'
import { tenant2, WfsPage, FdrPage, FfnPage, BillsPage } from 'utils/environmentConfig'

const AchieveRLogoSVG = dynamic(() => import('components/Svgs/AchieveRLogoSVG.js'))
const AchieveProLogoSVG = dynamic(() => import('components/Svgs/AchieveProLogoSVG.js'))
const Website2LogoSVG = dynamic(() => import('components/Svgs/Website2LogoSVG.js'))
const Website3LogoSVG = dynamic(() => import('components/Svgs/Website3LogoSVG.js'))
const WebsiteBillsLogoSVG = dynamic(() => import('components/Svgs/WebsiteBillsLogoSVG.js'))

const ACHIEVE_PRO_ROUTE = '/achieve-pro'

export const CurrentSvg = ({ siteEnv, ...props }) => {
  const { route } = props || {}
  switch (siteEnv) {
    case WfsPage:
      return (
        <Image
          src="/wfs-logo-dark.png"
          title="WFS Logo"
          alt="WFS Logo"
          width={246}
          height={87}
          {...props}
        />
      )
    case tenant2:
      return <Website2LogoSVG title="website-tenant-2" alt="website-tenant-2" {...props} />
    case FdrPage:
      return <Website2LogoSVG title="FDR Logo" alt="FDR Logo" {...props} />
    case FfnPage:
      return <Website3LogoSVG title="FFN Logo" alt="FFN Logo" {...props} />
    case BillsPage:
      return <WebsiteBillsLogoSVG title="Bills Logo" alt="Bills Logo" {...props} />
    default:
      if (route?.startsWith(ACHIEVE_PRO_ROUTE)) {
        return <AchieveProLogoSVG title="Achieve Pro" alt="Achieve Pro" {...props} />
      }
      return <AchieveRLogoSVG title="Achieve Logo" alt="Achieve Logo" {...props} />
  }
}
